import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ErrorSubmitService } from 'src/app/shared/service/errorSubmit/error-submit.service';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
})
export class DynamicFormComponent implements OnInit {
  @Input() model: any = {};
  @Input() action: any = {};
  @Input() canSave: boolean = false;
  @Output() submitted: EventEmitter<any> = new EventEmitter();
  public myEventData: any;
  public dynamicFormGroup!: FormGroup;
  public fields: any = [];
  guardando: boolean = false;
  constructor(
    private toastrService: ToastrService,
    private errorSubmitService: ErrorSubmitService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.submitted.subscribe((e) => {
      this.guardando = true;
      console.log(e);
    });
    this.errorSubmitService.errorEvent.subscribe((data: any) => {
      console.log(data);
      if (data === 'error') {
        this.guardando = false;
      }
    });
  }

  private buildForm() {
    const formGroupFields = this.getFormControlsFields();
    this.dynamicFormGroup = new FormGroup(formGroupFields);
  }

  private getFormControlsFields() {
    const formGroupFields: any = {};
    for (const field of Object.keys(this.model)) {
      const fieldProps = this.model[field];
      const validators = this.addValidator(fieldProps.rules);

      formGroupFields[field] = new FormControl(
        { value: fieldProps.value, disabled: fieldProps.disabled || false },
        validators
      );
      this.fields.push({ ...fieldProps, fieldName: field });
    }
    console.log(formGroupFields);
    return formGroupFields;
  }

  private addValidator(rules: any) {
    if (!rules) {
      return null; // Devuelve null si no hay reglas de validación
    }
    const validators: any = [];
    Object.keys(rules).forEach((rule) => {
      switch (rule) {
        case 'required':
          if (rules.required) {
            validators.push(Validators.required);
          }
          break;
        case 'email':
          validators.push(Validators.email);
        case 'min':
          validators.push(Validators.minLength(rules.min));
          break;
        case 'max':
          validators.push(Validators.maxLength(rules.max));
          break;
        case 'validate':
          if (rules.validate) {
            validators.push(rules.validate);
          }
          break;
        // Agrega más casos aquí para futuras reglas de validación
      }
    });

    if (validators.length === 0) {
      return null; // Devuelve null si no se agregaron validadores
    }

    return validators;
  }

  guardar() {
    if (this.dynamicFormGroup.valid) {
      this.guardando = true;
      this.submitted.emit(this.dynamicFormGroup.value);
    } else {
      this.dynamicFormGroup.markAllAsTouched();
      this.toastrService.warning(
        'Por favor, completa correctamente todos los campos.'
      );
    }
  }

  cancelar() {
    this.toastrService.warning('Cancelado.');
    this.dialog.closeAll();
  }
}
